import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const LocationCSVUploadModalStyled = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: ${props => props.theme.textColorDark};
  ${mixins.forceScrollbar as any};
`;
